import type { Business } from "@/domain/business/types";

export type BusinessProfileGap = "address" | "phone" | "location";

/** Read off the saved row, never the live form: a partner who just cleared a
 *  field already gets that field's refusal, and one notice per gap beats two. */
export function businessProfileGaps(business: Business): BusinessProfileGap[] {
  const gaps: BusinessProfileGap[] = [];
  if (!business.addressStreet || !business.addressCity || !business.addressCode) {
    gaps.push("address");
  }
  if (!business.phone) gaps.push("phone");
  if (business.locationLatitude === null || business.locationLongitude === null) {
    gaps.push("location");
  }
  return gaps;
}

const GAP_LABELS: Record<BusinessProfileGap, string> = {
  address: "adresa",
  phone: "telefonní číslo",
  location: "poloha na mapě",
};

function consequence(gaps: BusinessProfileGap[]): string {
  const cannotBeFound = gaps.some((gap) => gap !== "phone");
  return cannotBeFound ? " Zákazníci podnik nenajdou." : "";
}

export function incompleteProfileNotice(gaps: BusinessProfileGap[]): string {
  const listed = gaps.map((gap) => GAP_LABELS[gap]).join(", ");
  return `Údaje podniku nejsou úplné, chybí: ${listed}.${consequence(gaps)} Doplňte chybějící údaje a uložte změny.`;
}
